import { useEffect, useState } from "react";
import { NextComponentType, NextPageContext } from "next";
import Head from "next/head";
import { ChakraProvider } from "@chakra-ui/react";
import { ThemeContext } from "pages/_app";
import { FAVICONS, getChakraTheme } from "@/lib/chakra/theme";
import { useAppDispatch, useAppSelector } from "@/lib/hooks";
import { setHostname } from "@/lib/reducers/app";
import { AppColorsWrapper } from "./AppColorsWrapper";

type Props = {
  pageProps: any;
  Component: NextComponentType<NextPageContext, any, any>;
};

export default function AppWrapper({ pageProps, Component }: Props) {
  const dispatch = useAppDispatch();
  const { hostname, clientType } = useAppSelector((state) => state.app);
  const [activeTheme, setActiveTheme] = useState<
    Record<string, any> | undefined
  >(undefined);

  useEffect(() => {
    if (typeof window !== "undefined" && hostname === "") {
      dispatch(setHostname({ hostname: window.location.host }));
    }
  }, [dispatch, hostname]);

  useEffect(() => {
    if (activeTheme === undefined && clientType) {
      setActiveTheme(getChakraTheme(clientType));
    }
  }, [activeTheme, clientType]);

  if (!clientType) return <></>;

  const favicon = `/static/${FAVICONS[clientType]}?v=${clientType}`;

  return (
    <>
      <Head>
        <link key="favicon" rel="icon" href={favicon} />
      </Head>
      <ThemeContext.Provider value={{ activeTheme, setActiveTheme }}>
        <ChakraProvider
          theme={activeTheme}
          toastOptions={{
            defaultOptions: {
              position: "bottom",
              duration: 3000,
              variant: "solid",
            },
          }}
        >
          <AppColorsWrapper>{<Component {...pageProps} />}</AppColorsWrapper>
        </ChakraProvider>
      </ThemeContext.Provider>
    </>
  );
}
